<style scoped lang="scss">
  .box-teacher{
    .title{
      font-size: 16px;
      color: #114e9a;
      padding-left: 20px;
      border-bottom: 1px solid #eeeeee;
      padding-top: 5px;
      padding-bottom: 5px;
      overflow: hidden;
    }
    .list{
      margin: 10px;
      color: #333333;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 15px;
      margin-bottom: 0;
      img{
        vertical-align: top;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-right: 15px;
        &[lazy=loading]{
          width: 20px;
          height: 20px;
          margin: 30px;
        }
      }
      font-size: 14px;
      .text-con{
        display: inline-block;
        line-height: 1.7;
        font-size: 12px;
        .name{
          color: #333333;
          font-size: 16px;
        }
        .label{
          color: #666666;
        }
      }
      .con{
        margin-top: 10px;
        font-size: 14px;
        line-height: 1.5;
        word-wrap: break-word;
      }
    }
  }
</style>
<template>
  <div class="box-teacher">
      <h3 :style="{color: color}" class="title">
        <span style="float: left;">
          <i class="iconfont icon-jiabin" style="margin-right: 10px;"></i>
        {{data.cpnTitle}} {{data.cpnData.length}} {{language == 'ch' ? '位' : ''}}
        </span>
        <span style="padding-right: 12px;color: red;font-size: 12px;margin-top: 4px;float: right;">{{data.cpnContent}}</span>      
       </h3>
      <div v-if="data.cpnData.length>0" class="list" v-for="(item,i) in data.cpnData" :key="i">
        <img class="avatar" v-lazy="item.uIcon ? item.uIcon : 'http://medcircle.cn/lib/img/tpl-default-avatar.jpg'" alt="">
        <ul class="text-con">
          <li class="name">{{item.uName}}</li>
          <li v-if="item.uTitle"><span>{{ $t("message.tpl3.menu.title") }}：</span> <span class="label">{{item.uTitle}}</span></li>
          <li v-if="item.uOrg"><span>{{ $t("message.tpl3.menu.org") }}: </span> <span class="label">{{item.uOrg}}</span></li>
        </ul>
        <div v-if="item.uDesc" class="con" v-html="item.uDesc"></div>
      </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      language: 'ch'
    }
  },
  props: {
    data:{
      type: Object
    },
    color: {
      type: String,
      defualt: '#333'
    }
  },
  methods: {},
  computed: {},
  mounted() {
    this.language = localStorage.getItem('locale')
  }
}
</script>




// WEBPACK FOOTER //
// teacher.vue?e60e85ec